import { render, staticRenderFns } from "./giftList.vue?vue&type=template&id=7d7ebea2&scoped=true"
import script from "./giftList.vue?vue&type=script&lang=js"
export * from "./giftList.vue?vue&type=script&lang=js"
import style0 from "./giftList.vue?vue&type=style&index=0&id=7d7ebea2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7ebea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7ebea2')) {
      api.createRecord('7d7ebea2', component.options)
    } else {
      api.reload('7d7ebea2', component.options)
    }
    module.hot.accept("./giftList.vue?vue&type=template&id=7d7ebea2&scoped=true", function () {
      api.rerender('7d7ebea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/giftList/giftList.vue"
export default component.exports